import { createSelector } from 'reselect';
import { UNINITIALIZED } from 'ContentUtils/constants/RequestStatus';
const getPantone = state => state.resources.pantone && state.resources.pantone.pantone;
export const getPantoneColors = createSelector([getPantone], pantone => pantone && pantone.pantoneColors || []);
export const getPantoneColorsFetchStatus = (state, props) => {
  const pantoneColorsRequestStatus = state.resources.pantone.pantoneColorsRequestStatus;
  return pantoneColorsRequestStatus && pantoneColorsRequestStatus[props.siteUrl] || UNINITIALIZED;
};
export const getPantoneColorsFetchError = createSelector([getPantone], pantone => pantone && pantone.error);